import { aRect, px } from '../../../pixel/canvas';
import type { Part } from '../../types';

// Requires foot_pair → draws at foot_left (a.x~28) and foot_right (a.x~36)
// Shoes draw downward and sideways from the foot anchor at bottom of leg

export const shoes: Record<string, Part> = {
  shoes_sneakers: {
    id: 'shoes_sneakers', category: 'shoes', name: 'Sneakers', requires: 'foot_pair',
    draw: (ctx, a, p) => {
      aRect(ctx, a.x, a.y, 8, 3, p.light);             // upper
      aRect(ctx, a.x, a.y + 2, 10, 2, p.trimDark);    // sole (wider)
      aRect(ctx, a.x, a.y, 8, 1, p.trimLight);        // toe highlight
      // Lace detail
      aRect(ctx, a.x - 1, a.y + 1, 4, 1, p.primary);
    },
  },
  shoes_boots: {
    id: 'shoes_boots', category: 'shoes', name: 'Boots', requires: 'foot_pair',
    draw: (ctx, a, p) => {
      aRect(ctx, a.x, a.y - 4, 7, 7, p.dark);          // boot shaft
      aRect(ctx, a.x, a.y + 2, 9, 2, p.dark);          // toe box
      aRect(ctx, a.x, a.y + 3, 9, 1, p.trimDark);     // sole
      aRect(ctx, a.x, a.y - 4, 5, 1, p.trimDark);     // top edge
    },
  },
  shoes_heels: {
    id: 'shoes_heels', category: 'shoes', name: 'Heels', requires: 'foot_pair',
    draw: (ctx, a, p) => {
      aRect(ctx, a.x + 1, a.y, 7, 2, p.accent);        // upper toe box (forward)
      aRect(ctx, a.x + 1, a.y + 2, 7, 1, p.accentDark);// sole
      // Heel post
      aRect(ctx, a.x - 2, a.y, 2, 4, p.accentDark);
      aRect(ctx, a.x - 2, a.y + 3, 2, 1, p.trimDark);
    },
  },
  shoes_sandals: {
    id: 'shoes_sandals', category: 'shoes', name: 'Sandals', requires: 'foot_pair',
    draw: (ctx, a, p) => {
      aRect(ctx, a.x, a.y + 1, 9, 1, p.trimDark);     // flat sole
      // Straps
      aRect(ctx, a.x - 1, a.y, 3, 2, p.accent);
      aRect(ctx, a.x + 2, a.y, 3, 2, p.accent);
      px(ctx, a.x, a.y + 1, p.trim);                  // sole toe
    },
  },
  shoes_slippers: {
    id: 'shoes_slippers', category: 'shoes', name: 'Slippers', requires: 'foot_pair',
    draw: (ctx, a, p) => {
      aRect(ctx, a.x + 1, a.y, 8, 2, p.primary);       // slipper body
      aRect(ctx, a.x + 2, a.y + 2, 8, 1, p.dark);      // sole
      aRect(ctx, a.x - 1, a.y, 4, 2, p.light); // heel back
    },
  },
  shoes_platform: {
    id: 'shoes_platform', category: 'shoes', name: 'Platform', requires: 'foot_pair',
    draw: (ctx, a, p) => {
      aRect(ctx, a.x, a.y - 1, 8, 3, p.accent);        // upper
      aRect(ctx, a.x, a.y + 2, 9, 3, p.dark);          // thick platform sole
      aRect(ctx, a.x, a.y + 2, 7, 1, p.trimDark);     // platform top edge
    },
  },
  shoes_bare: {
    id: 'shoes_bare', category: 'shoes', name: 'Bare Feet', requires: 'foot_pair',
    draw: (ctx, a, p) => {
      aRect(ctx, a.x, a.y, 7, 2, p.light);             // foot shape
      aRect(ctx, a.x + 1, a.y + 1, 5, 1, p.shadow);   // underfoot
      // Toes
      px(ctx, a.x + 2, a.y, p.light);
      px(ctx, a.x + 3, a.y, p.light);
    },
  },
};
